export default __webpack_public_path__ + "static/media/dark_help_icon.e1c97281.svg";